<template>
  <div class="overtimeRules page-bg">
    <Header headerTitle="充电信息"></Header>
    <div >
      <!-- section -->
      <section>
        <div class="cardAddress panel">
          <h7>终端信息</h7>
          <div class="charge-info-wrapper">
            <div v-if="orderDetail.parkingSpace" class="equipment-desc-container">
              <div class="equipment-desc">终端编号: {{ orderDetail.parkingSpace.equipmentCode }}</div>
              <div v-if="orderDetail.parkingSpace.describe1" class="equipment-desc">{{ orderDetail.parkingSpace.describe1 }}</div>
              <div v-if="orderDetail.parkingSpace.describe2" class="equipment-desc">{{ orderDetail.parkingSpace.describe2 }}</div>
              <div v-if="orderDetail.parkingSpace.describe3" class="equipment-desc">{{ orderDetail.parkingSpace.describe3 }}</div>
            </div>
            <!-- <div class="right-charge-container">
              <div class="text-wrapper_2">
                <div class="text-wrapper_info">{{ chargeGunStatusStr }}</div>
              </div>

              <div class="right-charge-tip">
                {{ result.chargeGunSyncTime }} {{ chargeGunStatusStr }}
              </div>
            </div> -->
            <div class="circle" v-if="chargeGunStatusStr">
              {{ chargeGunStatusStr }}
            </div>
          </div>
          <div class="circle-desc" v-if="this.chargeGunStatusStr === '已插枪' && result.chargeGunSyncTime">
            {{ result.chargeGunSyncTime }} {{ chargeGunStatusStr }}
          </div>
        </div>
        <div class="cardAddress panel" style="margin-top:8px; margin-bottom: 240px">
          <h7 style="margin-top: 8px">价格信息<span style="font-size: 11px; color: #6F6F6F"> 全天统一价格</span></h7>
          <div class="space-name">{{ orderDetail.chargeUnitAmount }}元/度</div>
        </div>
      </section>
      <div class="footer-bg">
        <div v-if="result.chargeGunStatus === 2" class="equipment-tip">{{ equipmentTip }}</div>
        <div v-if="result.chargeGunStatus === 1" class="equipment-tip">
          请插枪后点击
          <span v-if="result.chargeGunStatus === 1" style="color: #0061B1" @click="refreshPage">刷新页面</span>，如刷新后仍不显示"已插枪"状态，请
          <span v-if="result.chargeGunStatus === 1" style="color: #0061B1" @click="goChargeHelp">点击这里</span>查看</div>
        <b-btn v-b-modal.modal-center style="background-color: #0061B1; color: #FFFFFF; width: 100%; margin-top: 8px"
               :disabled="chargeGunStatusStr !== '已插枪'"
               @click="handleCharge">{{ chargeBtnTitle }}</b-btn>
<!--        <div v-if="result.chargeGunStatus === 2" class="equipment-stop-tip" @click="goChargeStop">无法停止充电?</div>-->
        <!-- 取消订单 modal -->
      </div>
    </div>

    <b-modal ref="notice-start-charge" id="notice-start-charge" no-close-on-backdrop class="notice" static ok-title="启动充电"
             cancel-title="取消" @ok="startCharge(1)">
      <h5 style="margin-top: 12px"><b><strong>{{ noticeTitle }}</strong></b></h5>
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:14px;">
        {{ noticeInfo }}
      </p>
    </b-modal>

    <b-modal ref="notice-charge-tip" id="notice-charge-tip" no-close-on-backdrop class="notice" static hide-footer
             cancel-title="取消" @ok="startCharge(1)">
      <h5 style="margin-top: 12px"><b><strong>{{ noticeTitle }}</strong></b></h5>
      <p class="my-sm-6" style="margin-bottom:5px !important;padding:0 25px;font-size:16px;">
        安全充电启动中，请耐心等待，预计需要<span style="color: #0061B1"> {{ noticeInfo }} </span>启动成功。启动中，请勿拔枪启动过程中拔枪会造成充电异常，并可能发生安全风险
      </p>
    </b-modal>

    <!-- 提示信息 -->
    <Tip :message="message" :type="tipType" :show="tipShow"></Tip>

    <!-- 遮罩层 -->
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <van-loading type="circular"/>
        </div>
      </div>
    </van-overlay>
  </div>
</template>
<script>
import { timeOutPricingDetails } from "@/api/public.js";
import { parkingTime } from "@/api/time.js";
import { hourtoMinute } from "@/utils/DateFomatUtil";
import { orderListByDetails, startCharge } from "@/api/order.js";

export default {
  name: "OvertimeRules",
  data() {
    return {
      overTimeList: {},
      message: "", //提示信息
      tipShow: "0", //是否提示
      tipType: "", //提示类型
      equipmentTip: '设备已准备就绪，请启动充电',
      chargeBtnTitle: '启动充电',
      noticeTitle: '',
      noticeInfo: '',
      chargeInterval: undefined,
      orderId: undefined,
      orderDetail: { parkingSpace: null },
      result: { chargeGunSyncTime: null },
      chargingTime: 90,
      parkingTimeInterval: undefined,
      startChargeRes: undefined,
      chargeGunStatusStr: undefined,
      chargeGunIntervalStatus: undefined,
      show: false,
    };
  },
  destroyed() {
    if (this.chargeInterval != null) {
      clearInterval(this.chargeInterval);
    }
    if (this.parkingTimeInterval != null) {
      clearInterval(this.parkingTimeInterval);
    }
    if (this.chargeGunIntervalStatus != null) {
      clearInterval(this.chargeGunIntervalStatus);
    }
  },
  mounted() {
    this.orderId = this.$route.params.orderId; //订单Id
    this.handleOrderDetail()
    this.intervalChargeGunStatus()
  },
  methods: {
    goChargeHelp() {
      this.$router.push("/chargeHelp");
    },
    refreshPage() {
      location.reload();
      // this.handleParkingTime()
      // this.handleOrderDetail()
    },
    handleParkingTime() {
      parkingTime({orderId: this.orderId}).then(res => {
        if (res.data.status == 200) {
          this.result = res.data.result;

          if (this.result.chargeGunStatus === 255) {
            this.chargeGunStatusStr = '故障'
          }
          if (this.result.chargeGunStatus === 1) {
            this.chargeGunStatusStr = '未插枪'
          }
          if (this.result.chargeGunStatus > 1 && this.result.chargeGunStatus < 255) {
            this.chargeGunStatusStr = '已插枪'
          }


          if(this.result.chargeInfo && this.result.chargeInfo.chargeStatus === 2){
            this.$router.push("/chargeInfo/" + this.orderId);
            this.$refs["notice-charge-tip"].hide()
          }
        }
      })
    },
    handleOrderDetail() {
      orderListByDetails({
        orderId: this.orderId
      }).then(res => {
        this.orderDetail = res.data.result;

        if(this.orderDetail.status !== 3){
          this.$router.push("/Time/" + this.orderId);
        }
      });
    },
    noticeStartCharge() {
      this.noticeTitle = '确定启动充电？'
      this.noticeInfo = '充电前，请先熄火，电动汽车需要在熄火的状态下进行充电，建议同时关闭车内电源'
      this.$refs["notice-start-charge"].show();
    },
    handleCharge() {
      this.noticeStartCharge()
    },

    startCharge() {
      const self = this
      self.chargingTime = 90
      if (this.chargeGunIntervalStatus != null) {
        clearInterval(this.chargeGunIntervalStatus);
      }

      startCharge({
        orderId: this.orderId
      }).then(res => {
        self.show = false
        if (res.status === 200 && res.data.status === 200 && res.data.result.chargeResponse.SuccStat === 0) {
          this.startChargeRes = res;

          this.noticeTitle = '温馨提示'
          this.noticeInfo = this.chargingTime + 's'
          this.$refs["notice-charge-tip"].show();

          this.chargeInterval = setInterval(function () {
            if(self.chargingTime <= 0) {
              clearInterval(self.parkingTimeInterval)
              clearInterval(self.chargeInterval)
              self.intervalChargeGunStatus()
              self.$refs["notice-charge-tip"].hide()

              self.tipShow = "1" + Math.random() * 1000;
              self.message = '充电启动超时, 请重试';
              self.tipType = "warning";
            }

            self.chargingTime = self.chargingTime - 1
            self.noticeInfo = self.chargingTime + 's'
          }, 1000);

          this.parkingTimeInterval = setInterval(function () {
            self.handleParkingTime()
          }, 3000);
        } else {
          self.intervalChargeGunStatus()
          self.tipShow = "1" + Math.random() * 1000;
          self.message = '充电启动失败, 请重试';
          self.tipType = "warning";
        }
      })
    },
    goChargeStop() {
      this.$router.push("/chargeStop/" + this.orderId);
    },
    //加载数据
    loadOverTimeList: function() {
      timeOutPricingDetails({}).then(
          response => {
            if (response.data.status == 200) {
            } else {
              this.tipShow = "1" + Math.random() * 1000;
              this.message = response.data.message;
              this.tipType = "warning";
            }
          },
          err => {
            reject(err);
          }
      );
    },
    // 轮询插枪状态
    intervalChargeGunStatus() {
      let that = this
      this.chargeGunIntervalStatus = setInterval(function () {
        parkingTime({orderId: that.orderId}).then(res => {
          console.log("订单id：", that.orderId)
          console.log("插枪状态：", that.chargeGunStatusStr)
          if (res.data.status === 200) {
            that.result = res.data.result

            if (that.result.chargeGunStatus === 255) {
              that.chargeGunStatusStr = '故障'
            }
            if (that.result.chargeGunStatus === 1) {
              that.chargeGunStatusStr = '未插枪'
            }
            if (that.result.chargeGunStatus > 1 && that.result.chargeGunStatus < 255) {
              if (that.chargeGunStatusStr !== '已插枪') {
                // 打开蒙层
                that.show = true;

                // 发起充电请求
                console.log("准备发起充电")
                that.startCharge(1)
              }

              that.chargeGunStatusStr = '已插枪'
            }

            if(that.result.chargeInfo && that.result.chargeInfo.chargeStatus === 2){
              that.$router.push("/chargeInfo/" + that.orderId);
              that.$refs["notice-charge-tip"].hide()
            }
          } else {
            if (that.chargeGunIntervalStatus != null) {
              clearInterval(this.chargeGunIntervalStatus)
            }
            that.tipShow = "1" + Math.random() * 1000;
            that.tipType = "warning";
            that.message = res.data.message;
          }
        })
      }, 3000)
    }
  }
};
</script>
<style>
.overtimeRules, .main-container {
  height: calc(100% - 50px);
}
.overtimeRules section {
  width: 100%;
  height: 65%;
  padding: 10px;
}

.overtimeRules section .row {
  padding: 0 15px;
}
.overtimeRules section .row .col-12 {
  background-color: #f1f1f1;
  justify-content: center;
  margin-bottom: 3px;
  line-height: 70px;
}
.overtimeRules section .row .col-4 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  height: 100px;
  margin-bottom: 3px;
  font-size: 0.98rem;
  padding: 0;
  text-align: center;
}
.overtimeRules section .row .col-8{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  height: 100px;
  margin-bottom: 3px;
  text-align: left;
  margin-left: 5px;
  max-width: 65%;
}
.equipment-tip {
  text-align: left;

  font-size: 12px;
  font-weight: 400;
  color: #575757;
  line-height: 18px;
}
.equipment-stop-tip {
  text-align: left;
  font-size: 12px;
  font-weight: 400;
  color: #0061B1;
  line-height: 33px;
}
.right-charge-container {
  display: flex;
  flex-direction: column;
  width: 102px;
}
.right-charge-tip {
  overflow-wrap: break-word;
  color: rgba(0, 97, 177, 1);
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  border: 1px solid rgba(0, 97, 177, 1);
  border-radius: 6px;
  margin-top: 6px;
}
.text-wrapper_2 {
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb9321e3490d214f4bc8b3d8bc057eb0d731160a259447c8285ab8b3b10a78801) -23px -23px
  no-repeat;
  width: 100%;
  background-size: 148px 148px;
  padding: 33px 12px 32px 12px;
}
.text-wrapper_info {
  width: 100%;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  font-size: 24px;
}
.charge-info-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
</style>
<style >
.circle {
  width: 55px;
  height: 55px;
  border-radius: 50px;
  line-height: 55px;
  color: white;
  font-weight: bold;
  text-align: center;
  box-shadow: 0 2px 12px 0 #c0b9b9;
  background-image: linear-gradient(#00BFFF, #0081FE);
  transition: all 0.5s ease-in-out;
  animation: ripple 1.8s linear infinite;
  margin-right: 4%;
  font-size: 14px;
}
@keyframes ripple {
  0% {
    box-shadow: 0 0 0 0 rgb(255 255 255 / 25%),
    0 0 0 4px rgba(87, 205, 245, 0.25),
    0 0 0 15px rgba(214, 235, 240, 0.25);
  }
  100% {
    box-shadow: 0 0 0 10px rgb(255 255 255 / 25%),
    0 0 0 15px rgba(216, 231, 243, 0.25),
    0 0 0 20px rgba(223, 238, 239, 0);
  }
}

.page-bg section {
  padding: 0px!important;
}
.circle-desc{
  margin-top: -5%;
  overflow-wrap: break-word;
  color: rgba(0, 97, 177, 1);
  font-size: 12px;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  line-height: 22px;
  border: 1px solid rgba(0, 97, 177, 1);
  border-radius: 6px;
  width: 75px;
  float: right;
  background: #EAF5FD;
  margin-right: 2%;
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 120px;
  height: 120px;
}


</style>>



